module.exports = __webpack_public_path__ + "static/media/mp4.410ab157.svg";